import type { ImageData } from 'ricos-schema';
import { Node_Type } from 'ricos-schema';

import type { NodeBuilder } from './types';
import { isDefined } from './utils';

export const image = (...args: (NodeBuilder | ImageData)[]): NodeBuilder => {
  const imageData = args.find((a): a is ImageData => !('type' in a));

  return {
    type: 'block_node',
    // @ts-ignore
    node: getId => {
      const nodes = args
        .map(arg => ('type' in arg && arg.type === 'block_node' ? arg.node(getId) : undefined))
        .filter(isDefined);

      return {
        id: getId(),
        type: Node_Type.IMAGE,
        imageData: imageData ? imageData : {},
        ...(nodes?.length && { nodes }),
      };
    },
  };
};
